import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { Company } from '@/types';

interface IGetCompanyRequestsListTableStructureProps {
  store: any;
  createAction?: () => void;
  rowActionsFn?: (target: Company) => DataTableRowActions;
}

export const getCompanyRequestsListDataTableStructure = ({
  store,
  createAction,
  rowActionsFn,
}: IGetCompanyRequestsListTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const nifColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.nif',
    accessorKey: 'nif',
    variant: DataTableColumnVariant.TEXT,
  };

  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };

  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.firstName',
    accessorKey: 'responsablePrenom',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.lastName',
    accessorKey: 'responsableNom',
    variant: DataTableColumnVariant.TEXT,
  };

  const inChargeEmailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.emailResponsable',
    accessorKey: 'responsableEmail',
    variant: DataTableColumnVariant.TEXT,
  };

  const countryColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.country',
    accessorKey: 'pays',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.companyInfo.table.singular',
    plural: 'settings.companyInfo.table.plural',
    columns: [idColumn, nameColumn, nifColumn, emailColumn, firstNameColumn, lastNameColumn, inChargeEmailColumn, countryColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: any) => {
      store.set('dto', {
        nom: row.nom,
        typeId: row.type?.id,
        nif: row.nif,
        dateNif: row.dateNif,
        numCnss: row.numCnss,
        status: row.status,
        categorieSoumissionnaireId: row.categorieSoumissionnaire?.id,
      });
      store.set('response', row);
      store.set('companyTypeSelected', { name: row.type?.code, code: row.type?.id });
      store.set('companyCategorySelected', { name: row.categorieSoumissionnaire?.code, code: row.categorieSoumissionnaire?.id });
    },
    createAction,
    rowActionsFn,
    searchableFields: ['id', 'nom', 'type.description', 'pays.description', 'nni', 'categorieSoumissionnaire.description'],
  };
};
